import React, { useContext, useEffect, useState } from 'react'
import { WhatsappContext } from './Whatsapp';

function ChatHeaderImage() {
    const { stateWhatsApp, dispatchWhatsApp } = useContext(WhatsappContext);
    const [renderImage, setrenderImage] = useState(<div className="ticket-sender-picture p-1 m-0 col-auto"></div>)
    useEffect(() => {
        if (stateWhatsApp.active != null && stateWhatsApp.chat != null) {
            // /TODO:change to user profile
            setrenderImage(
                <div className="ticket-sender-picture p-1 m-0 col-auto">
                    <img src="../assets/img/avatar/avatar-5.png" width="70px" alt="image" />
                </div>
            )
        } else {
            setrenderImage(<div className="ticket-sender-picture p-1 m-0 col-auto"></div>)
        }
    }, [stateWhatsApp.active, stateWhatsApp.chat])
    return (
        renderImage
    )
}

export default ChatHeaderImage
